import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract.js'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { poItemsUpdate } from '@/api/seaExport/poItems'
import { PoItems } from '@/class/model/booking/PoItems'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { jdySendPoItems, jdyUnlockStatus } from '@/api/seaExport/seaExportJob'

export class TabTradeDetailBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission
  }

  get context() {
    return this.view.context
  }

  set context(context) {
    this.view.context = context
  }

  get user() {
    return this.view.context.user
  }

  set user(user) {
    this.view.context.user = user
  }

  get config() {
    return this.view.config
  }

  set config(config) {
    this.view.config = config
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }

  get poItems() {
    return this.view.poItems
  }

  set poItems(poItems) {
    this.view.poItems = poItems
  }

  get delPoItemsUuids() {
    return this.view.delPoItemsUuids
  }

  set delPoItemsUuids(delPoItemsUuids) {
    this.view.delPoItemsUuids = delPoItemsUuids
  }

  async loadPoItems(isRefresh = false) {
    // 加载数据
    const job = new SeaImportJob(this.job)

    // 添加/移除装箱 需要强制刷新grid
    if (isRefresh) {
      job.poItems = ''
      job.containerUsages = ''
    }

    await Promise.all([
      job.getPoItems(),
      job.getContainerUsages()
    ])
    this.poItems = this.job.poItems
  }
  // 新增
  addBtnClickHandler() {
    const poItems = new PoItems().fillDefaultValue().getData()
    poItems.purchaseCurrency = 'USD'
    poItems.jobUuid = this.job.uuid
    if (this.poItems) {
      if (this.poItems.length > 0) {
        const lastPoItems = this.poItems[0]
        if (lastPoItems) { poItems.purchaseCurrency = lastPoItems.purchaseCurrency }
      }
    }
    this.poItems.push(poItems)
    // gird 刷新
    this.view.$nextTick(() => {
      this.view.gridApi.refreshCells({ force: true })
    })
  }
  // 删除
  delBtnClickHandler() {
    const selections = this.view.gridApi.getSelectedRows()
    if (selections.length > 0) {
      for (const item of selections) {
        if (item.uuid) {
          this.delPoItemsUuids.push(item.uuid)
        }
        const index = this.poItems.findIndex(p => p === item)
        this.poItems.splice(index, 1)
      }
    }
  }
  // button click 关联装箱信息
  relatedContainerHandler() {
    // 获取选中项
    var selPoItems = this.view.gridApi.getSelectedRows()

    if (selPoItems == null || selPoItems.length === 0) {
      this.$message.warning(this.view.$t('Message.CargoDetailsIsNotSelected'))
      return
    } else {
      for (const item of selPoItems) {
        if (item.related === 1) {
          this.$message.warning(this.view.$t('Message.PleaseSelectUnRelatedTradeDetailData'))
          return
        }
      }
    }
    const containerUsageKeys = []
    for (const keyItem of this.poItems) {
      if (keyItem.containerUsageKey && !containerUsageKeys.includes(keyItem.containerUsageKey)) {
        containerUsageKeys.push(keyItem.containerUsageKey)
      }
    }

    this.view.tradeDetailContainerLinkedDialog.selPoItems = selPoItems
    this.view.tradeDetailContainerLinkedDialog.relatedContainerUsage = containerUsageKeys
    this.view.tradeDetailContainerLinkedDialog.visible = true
  }
  // 关联装箱信息 处理
  async linkUsagesEventHandler(data) {
    const linkedContainerUsage = data
    const selectedPoItems = this.view.gridApi.getSelectedRows()
    if (selectedPoItems && selectedPoItems.length > 0) {
      for (const item of selectedPoItems) {
        if (linkedContainerUsage.container) {
          item.eqSize = linkedContainerUsage.container.eqSize
          item.eqType = linkedContainerUsage.container.eqType
          item.containerNo = linkedContainerUsage.container.containerNo
          item.sealNo = linkedContainerUsage.container.sealNo
          item.related = 1
          item.containerUsageKey = linkedContainerUsage.uuid
        }
      }
      await poItemsUpdate(selectedPoItems)
      this.$message.success(this.view.$t('Message.OperationSuccessfully'))
      // 刷新grid
      this.loadPoItems(true)
    }
  }

  /**
   * button click 移除关联
   */
  removeRelatedContainerHandler() {
    const selTrades = this.view.gridApi.getSelectedRows()
    if (selTrades == null || selTrades.length === 0) {
      this.$message.warning(this.view.$t('Message.PleaseSelectData'))
      return
    } else if (selTrades.length > 1) {
      this.$message.warning(this.view.$t('Message.OnlySelectOneData'))
      return
    } else {
      const sel = selTrades[0]
      const selContainerUsageKey = sel.containerUsageKey
      const datas = this.poItems
      if (!sel.containerUsageKey) {
        this.$message.warning(this.view.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      const associatePoItems = []
      this.$confirm(this.view.$t('queryJob.CaseNo') + sel.containerNo + this.view.$t('queryJob.AllTheAssociationDoContinue'), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        for (const poItem of datas) {
          if (poItem.containerUsageKey === selContainerUsageKey) {
            poItem.eqSize = null
            poItem.eqType = null
            poItem.containerNo = null
            poItem.sealNo = null
            poItem.related = 0
            poItem.containerUsageKey = null
            associatePoItems.push(poItem)
          }
        }
        if (associatePoItems && associatePoItems.length > 0) {
          await poItemsUpdate(associatePoItems)
          this.$message.success(this.view.$t('Message.RemovedSuccesfully'))
          // 刷新grid
          this.loadPoItems(true)
        }
      })
    }
  }

  /**
   * 下载模板
   */
  downTemplateBtn_clickHandler() {
    const fileName = 'PoItemsImportTemplate.xls'
    const folderName = 'price'
    ExportUtils.downloadTemplateFile(fileName, folderName)
  }
  //  excel 导入后逻辑处理
  onImportSucceeded(data) {
    let count = 0
    if (data && data.poItemsList && data.poItemsList.length > 0) {
      if (this.job) {
        count = data.poItemsList.length
        for (const item of data.poItemsList) {
          this.poItems.push(item)
        }
      }
    }
    this.$message.success(this.view.$t('Message.ImportSuccessful1') + count + this.view.$t('Message.ImportSuccessful2'))
  }
  /**
   * Excel 导出
   */
  exportBtnClickHandler() {
    const rows = this.view.gridApi.getSelectedRows()
    if (rows.length === 0) {
      this.$message.warning(this.view.$t('Message.SelectTheData'))
      return
    }
    const header = []
    const filterVal = []
    const data = rows.map(row => {
      const obj = {}
      for (const column of this.view.columnDefs) {
        if (!column.headerName || !column.field) continue
        if (!header.includes(column.headerName)) {
          header.push(column.headerName)
        }
        if (typeof column.cellRenderer === 'function') {
          obj[column.field] = column.cellRenderer({ data: row, value: row[column.field] })
        } else {
          obj[column.field] = row[column.field]
        }
        filterVal.push(column.field)
      }
      return obj
    })
    const dataConvert = this.formatJson(filterVal, data)
     import('@/vendor/Export2Excel').then(excel => {
       excel.export_json_to_excel({
         header,
         data: dataConvert,
         filename: this.view.$t('queryJob.DetailsAirExportGoodsXls')
       })
     })
  }
  formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  }
  /**
   * 打印
   */
  onBatchPrint() {
    var selectedPoItems = this.view.gridApi.getSelectedRows()
    if (selectedPoItems.length === 0) {
      this.$message.warning(this.view.$t('Message.CargoDetailsIsNotSelected'))
      return
    }
    const uids = []
    for (const j of selectedPoItems) {
      uids.push(j.uuid)
    }
    if (uids.length > 0) {
      this.view.templateSelectorDialog.visible = true
      this.view.templateSelectorDialog.data = { 'POITEMS_UUID': uids }
    }
  }
  // 卖价计算按钮点击事件
  fentanBtnClickHandler() {
    this.calculateSell()
  }
  calculateSell() {
    // 计算Amount(RMB)
    const amountRMBTotal = this.rmbTotal()
    const receivable = this.getReceivable()
    if (this.view.poItems) {
      for (const poItems of this.view.poItems) {
        this.calculatePoItemsSell(poItems, amountRMBTotal, receivable)
      }
    }
    this.$message.info('卖价计算完成')
  }
  rmbTotal() {
    let result = 0
    if (this.view.poItems) {
      for (const poItems of this.view.poItems) {
        result += Number(Math.round(poItems.purchaseAmount * poItems.pruchaseExchangeRate).toFixed(2))
      }
    }
    return result
  }

  getReceivable() {
    if (!this.view.job.charges) {
      this.view.job.charges = new SeaImportJob(this.view.job).getCharges()
    }
    if (!this.view.job.charges || this.view.job.charges.length === 0) return 0
    let result = 0
    for (const charge of this.view.job.charges) {
      if (charge && charge.receivable) {
        result += Number(((charge.excludingTaxAmount + charge.taxAmount) * charge.exchangeRate).toFixed(2))
      }
    }
    return result
  }

  // 发送信息对接到简道云平台
  async sendToJdyPlatform() {
    const jobUuids = []
    jobUuids.push(this.job.uuid)
    const branchId = this.$store.getters.currentOfficeId
    const loading = getLoading()
    await jdySendPoItems({ branchId: branchId, jobUuids: jobUuids }).then(res => {
      const data = res.data
      if (data && data.successNum === 0 && data.failNum === 0) {
        this.$message.warning(this.view.$t('Message.NoSendingGoodsInfo'))
        return
      }
      if (data && data.successNum && data.failNum === 0) {
        this.$message.success(this.view.$t('Message.SuccessfullySent'))
        return
      }
      if (data && data.failNum) {
        const failList = data.jdyPoItemFailVOS || []
        let errorMessage = this.view.$t('SeaExport.sendFailInfo').replace('{0}', data.successNum).replace('{1}', data.failNum) + `<br>`
        failList.forEach((failItem, index) => {
          errorMessage += `${index + 1}. ` + this.view.$t('Clearing.BusinessNumber') + `：${failItem.jobNo} Order NO：${failItem.orderNo} ItemNO：${failItem.itemNo}` + this.view.$t('CargoMsg.Cargo_ResultMessage') + `: ${failItem.reason}<br>`
        })
        this.$message.warning({
          message: errorMessage,
          dangerouslyUseHTMLString: true
        })
      }
    }).finally(() => {
      loading.close()
    })
    // 刷新grid
    await this.loadPoItems(true)
  }
  async sendToPlatformUnlock() {
    this.view.sendToPlatformUnlock = false
    this.job.lockStatus = false
    const jobUuids = []
    jobUuids.push(this.job.uuid)
    const loading = getLoading()
    await jdyUnlockStatus(jobUuids).then(res => {
      this.$message.success(this.view.$t('CargoMsg.Cargo_UnLockLabel') + this.view.$t('CargoMsg.Cargo_Success'))
    }).finally(() => {
      loading.close()
    })
    this.view.gridApi.refreshCells({ force: true })
  }
  // 计算
  calculateAmount(poItems) {
    // 人民币
    const rmb = Math.round(poItems.purchaseAmount * poItems.pruchaseExchangeRate)
    // 关税
    poItems.purchaseTariffAmount = rmb * poItems.purchaseTariffRate / 100
    poItems.purchaseTariffAmount = Number(poItems.purchaseTariffAmount.toFixed(2))
    // 增值税
    poItems.purchaseValAmount = ((rmb + poItems.purchaseTariffAmount) * poItems.purchaseValRate) / (100 - poItems.purchaseExciseRate)
    poItems.purchaseValAmount = Number(poItems.purchaseValAmount.toFixed(2))
    // 消费税
    poItems.purchaseExciseAmount = rmb * poItems.purchaseExciseRate / 100
    poItems.purchaseExciseAmount = Number(poItems.purchaseExciseAmount.toFixed(2))
    this.view.gridApi.refreshCells({ force: true })
  }

  // 分摊
  calculatePoItemsSell(poItems, totalValue, receivable) {
    // AMOUNT
    poItems.sellAmount = receivable * poItems.purchaseAmount * poItems.pruchaseExchangeRate / totalValue
    poItems.sellAmount = Number(poItems.sellAmount.toFixed(2))
    poItems.sellAmount = isNaN(poItems.sellAmount) ? 0 : poItems.sellAmount
    // 货价
    poItems.sellPrice = poItems.sellAmount / (1 + poItems.sellValRate / 100)
    poItems.sellPrice = Number(poItems.sellPrice.toFixed(2))
    poItems.sellPrice = isNaN(poItems.sellPrice) ? 0 : poItems.sellPrice
    // 税金
    poItems.sellValAmount = poItems.sellPrice * poItems.sellValRate / 100
    poItems.sellValAmount = Number(poItems.sellValAmount.toFixed(2))
    poItems.sellValAmount = isNaN(poItems.sellValAmount) ? 0 : poItems.sellValAmount
    this.view.gridApi.refreshCells({ force: true })
  }
}
